<template>
    <canvas
        id="fireworks-canvas"
        :style="shouldDisplay ? 'display: block;' : 'display: none;'"
    ></canvas>
</template>

<script>
import { fire } from "./fireworks";
export default {
    data() {
        return {
            lightLogos: [],
            shouldDisplay: false
        };
    },

    mounted() {
        const that = this;
        this.$eventHub.$on("fireworks-trigger", () => {
            that.shouldDisplay = true;
            fire();
        });
        this.$eventHub.$on("fireworks-end", () => {
            that.shouldDisplay = false;
        });
    }
};
</script>
